import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class EdAddPaperWriteObject extends Vue {

  @Prop() readonly paperUploaded: any;

  public dropCoverOptions: any = {
    url: 'http://eduac/upload',
    autoProcessQueue: false,
    acceptedFiles: 'image/*',
    addRemoveLinks: true,
    uploadMultiple: false,
    maxFiles: 1,
    maxFilesize: 100,
    parallelUploads: 1,
    timeout: 600000
  }

  public dropPaperOptions: any = {
    url: 'http://eduac/upload',
    autoProcessQueue: false,
    acceptedFiles: 'application/pdf',
    addRemoveLinks: true,
    uploadMultiple: false,
    maxFiles: 1,
    maxFilesize: 100,
    parallelUploads: 1,
    createImageThumbnails: false,
    timeout: 600000
  }

  public coverFile: any = null;
  public paperFile: any = null;

  public showCoverDropzone: boolean = true;

  get hasPaper() {
    return this.paperFile ? true : false;
  }

  get hasCover() {
    return this.coverFile ? true : false;
  }

  get cover() {
    let img = this.coverFile.dataURL;
    return {'background-image': `url(${img})`};
  }

  get paperFilename() {
    return this.paperFile.name;
  }

  onCoverAdded(file: any) {
    this.showCoverDropzone = false;
    setTimeout(() => {
      this.coverFile = file;
    }, 500);
  }

  onPaperAdded(file: any) {
    this.paperFile = file;
  }

  removeCover() {
    this.showCoverDropzone = true;
    this.coverFile = null;
  }

  removePaperFile() {
    this.paperFile = null;
  }

  updateData() {
    let success = this.coverFile && this.paperFile;
    this.$emit('paperUploaded', {
      success,
      cover: this.coverFile,
      paper: this.paperFile
    })
  }

  @Watch('coverFile')
  coverFileChanged() {
    this.updateData();
  }

  @Watch('paperFile')
  paperFileChanged() {
    this.updateData();
  }
  
}